const Teams = {
  BUSINESS: "business",
  CORE: "core",
  COURSES: "courses",
  CONTENT: "content",
  INTEGRATIONS: "integrations",
} as const;

export default Teams;
